import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { DateInput, Modal, TextInput } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { ToastMessages } from "../../../enums/toastMessages";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";
import { onSaveCaseInitiation } from "./actionHandlers/onSaveCaseInitiation";
import { useCaseInitiationForm } from "./hooks/useCaseInitiationForm";

interface CaseInitiationModalProps {
  onClose: () => void;
  onSave: () => void;
}

const CaseInitiationModal = (props: CaseInitiationModalProps) => {
  const { formData, handleFieldChange, isFormValid } = useCaseInitiationForm();

  const handleSave = () => {
    const orgId = getOrgIdForFetchExternalWorklist();

    if (!orgId) {
      toast.error(ToastMessages.CASE_INITIATION_NO_ORG_ID);
      return;
    }

    onSaveCaseInitiation(formData, orgId, () => {
      props.onSave();
      toast.success(ToastMessages.CASE_INITIATION_SUBMIT_SUCCESS);
      props.onClose();
    });
  };

  return (
    <>
      <Modal
        dialogId={ModalId.CASE_INITIATION_MODAL}
        title="Case Initiation"
        onClose={props.onClose}
        onSave={handleSave}
        saveButtonText="Save"
        cancelText="Cancel"
        disableSave={!isFormValid()}
      >
        <div className="flex flex-col gap-2">
          <TextInput
            label="Case Name"
            id="case-name"
            onChange={(data) => handleFieldChange("caseName", data.value)}
            placeholder="Enter Case Name"
            defaultValue={formData.caseName}
          />
          <div className="flex w-full flex-row gap-2">
            <div className="w-1/2">
              <TextInput
                label="MRN"
                id="mrn"
                onChange={(data) => handleFieldChange("mrn", data.value)}
                placeholder="Enter MRN"
                defaultValue={formData.mrn}
                required
              />
            </div>
            <div
              className="w-1/2"
              style={{
                overflow: "hidden",
              }}
            >
              <DateInput
                label="Case Date (DOB)"
                id="case-date"
                format="MM/DD/YYYY"
                onChange={(data) => handleFieldChange("caseDate", data.value)}
                defaultValue={formData.caseDate}
                required
              />
            </div>
          </div>
          <div className="flex w-full flex-row gap-2">
            <div className="w-1/2">
              <TextInput
                label="First Name"
                id="first-name"
                onChange={(data) => handleFieldChange("firstName", data.value)}
                placeholder="Enter First Name"
                defaultValue={formData.firstName}
                required
              />
            </div>
            <div className="w-1/2">
              <TextInput
                label="Last Name"
                id="last-name"
                onChange={(data) => handleFieldChange("lastName", data.value)}
                placeholder="Enter Last Name"
                defaultValue={formData.lastName}
                required
              />
            </div>
          </div>
          <TextInput
            label="Prescriber Name"
            id="prescriber-name"
            onChange={(data) => handleFieldChange("prescriberName", data.value)}
            placeholder="Enter Prescriber Name"
            defaultValue={formData.prescriberName}
            required
          />
          <TextInput
            label="Drug Name"
            id="drug-name"
            onChange={(data) => handleFieldChange("drugName", data.value)}
            placeholder="Enter Drug Name"
            defaultValue={formData.drugName}
            required
          />
          <TextInput
            label="Key"
            id="key"
            onChange={(data) => handleFieldChange("key", data.value)}
            placeholder="Enter Key"
            defaultValue={formData.key}
            required
          />
        </div>
      </Modal>
    </>
  );
};

export default CaseInitiationModal;
